import { Badge } from "../ui/badge";
import { CheckCircle, Clock, XCircle } from "lucide-react";
import { isJobExpired } from "../../utils/jobSlug";

export default function JobStatusBadge({ status, job, className = "" }) {
  if (job && isJobExpired(job)) {
    return (
      <Badge
        variant="secondary"
        className={`flex items-center gap-1 text-xs bg-amber-500/15 text-amber-800 border-amber-300/50 dark:text-amber-300 dark:border-amber-700/50 ${className}`}
      >
        <Clock className="w-3 h-3" />
        Expired
      </Badge>
    );
  }

  const map = {
    PENDING: { variant: "secondary", text: "Pending", icon: Clock, cls: "bg-yellow-500/10 border-yellow-300/50 text-yellow-800 dark:text-yellow-300" },
    APPROVED: { variant: "default", text: "Live", icon: CheckCircle, cls: "" },
    EXPIRED: { variant: "secondary", text: "Expired", icon: Clock, cls: "bg-amber-500/15 text-amber-800 border-amber-300/50 dark:text-amber-300" },
    CLOSED: { variant: "outline", text: "Closed", icon: XCircle, cls: "" },
    REJECTED: { variant: "destructive", text: "Rejected", icon: XCircle, cls: "" },
  };

  const s = map[status] || map.PENDING;
  const Icon = s.icon;

  return (
    <Badge variant={s.variant} className={`flex items-center gap-1 text-xs ${s.cls} ${className}`}>
      <Icon className="w-3 h-3" />
      {s.text}
    </Badge>
  );
}
